"use strict";

exports.__esModule = true;
exports.mobileFocusAreaClassesMap = exports.mobileFocusAreaClasses = exports.alignments = exports.alignmentMap = void 0;
var alignmentMap = {
  inset: 'imageInset',
  left: 'imageLeft',
  right: 'imageRight',
  "default": 'imageFull'
};
exports.alignmentMap = alignmentMap;
var alignments = Object.keys(alignmentMap);
exports.alignments = alignments;
var mobileFocusAreaClassesMap = {
  left: 'imageFocusLeft',
  centreLeft: 'imageFocusCentreLeft',
  centre: 'imageFocusCentre',
  centreRight: 'imageFocusCentreRight',
  right: 'imageFocusRight'
};
exports.mobileFocusAreaClassesMap = mobileFocusAreaClassesMap;
var mobileFocusAreaClasses = Object.keys(mobileFocusAreaClassesMap);
exports.mobileFocusAreaClasses = mobileFocusAreaClasses;